import React from 'react';
import PropTypes from 'prop-types';
import './../QuickView/QuickView.css';

interface ModalProps {
  isOpen: boolean;
  title: string;
  message: string;
  isWarning?: boolean;
  showCancel?: boolean;
  onConfirm: () => void;
  onCancel?: () => void;
}

const MessageModal: React.FC<ModalProps> = ({
  isOpen,
  title,
  message,
  isWarning = false,
  showCancel = false,
  onConfirm,
  onCancel,
}) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
      data-tag="custom-modal">
      <div className="bg-white shadow-lg w-96">
        <div className="px-4 py-4 flex justify-between items-center border-b">
          <h1 className={`text-lg font-bold uppercase ${isWarning && 'text-[#a61613]'}`}>{title}</h1>
        </div>
        <div className="p-4 border-t-[#e4e4e4] border-t border-solid">
          <p className="mb-4">{message}</p>
        </div>
        <div className="px-4 py-2 flex justify-end space-x-4 border-t-[#e4e4e4] border-t border-solid">
          {showCancel && (
            <button
              onClick={onCancel}
              className="btn-file bg-black text-white underline rounded"
            >
              Cancel
            </button>
          )}
          <div className="flex flex-row justify-end">
            <button
              className="outline-none hover:outline-none focus:outline-none border-0 underline text-sm text-error px-0 py-1 bg-inherit"
              onClick={onConfirm}
            >
              {isWarning ? 'Continue' : 'Confirm'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

MessageModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  title: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  isWarning: PropTypes.bool,
  showCancel: PropTypes.bool,
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func,
};

export default MessageModal;